module.exports = __webpack_public_path__ + "img/GYLFW_9.52a6776c.jpg";